import { REGISTERED_EMAIL, NOT_REGISTERED_EMAIL } from './actionTypes'

export const registeredEmail = () => {
    return {
        type: REGISTERED_EMAIL,
    }
}

export const notRegisteredEmail = () => {
    return {
        type: NOT_REGISTERED_EMAIL,
    }
}
